
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.911 19.501a1.231 1.231 0 01-1.191-1.56l1.053-3.864-2.846-2.847a1.225 1.225 0 01-.361-.872A1.232 1.232 0 015.68 9.13l3.414-.342 1.804-3.607a1.23 1.23 0 011.658-.55c.237.119.433.316.551.553L14.91 8.79l3.415.342a1.235 1.235 0 01.75 2.101l-2.844 2.844 1.054 3.863a1.232 1.232 0 01-.87 1.516 1.24 1.24 0 01-.872-.086l-3.541-1.771-3.54 1.772c-.174.086-.359.13-.551.13zm1.23-6.177c.19.19.264.469.193.728l-1.012 3.711 3.342-1.673a.749.749 0 01.671-.001l3.344 1.672-1.013-3.71a.751.751 0 01.193-.728l2.756-2.755-3.269-.327a.747.747 0 01-.596-.411L12 6.328l-1.751 3.501a.747.747 0 01-.596.411l-3.269.327 2.757 2.757z"}})])
          )
        }
      }
    